<template>
    <main-content>
        <action-bar>
            <div class="dropdown">
                <button class="btn btn-success dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                        v-text="$t('stakeholders.btn.add')">
                </button>
                <div class="dropdown-menu bg-secondary">
                    <router-link to="/stakeholders/create" class="dropdown-item">
                        {{ $t('stakeholders.btn.add_gateway_type_stakeholder') }}
                    </router-link>
                    <router-link to="/stakeholders/create-from-users" class="dropdown-item">
                        {{ $t('stakeholders.btn.add_from_users') }}
                    </router-link>
                    <router-link v-if="$can('update', 'user') && $can('update-info', 'ipg-gateway') && $can('change-setting', 'wallet')"
                                 to="/stakeholders/create-pf-type"
                                 class="dropdown-item"
                    >
                        {{ $t('stakeholders.btn.add_pf_type_stakeholder') }}
                    </router-link>
                </div>
            </div>
        </action-bar>
        <manage-data-table v-if="$can('read-general-info', 'user')" />
        <div v-else>
            <filter-bar :action="filterAction"></filter-bar>
            <kt-datatable v-bind="datatableProps" ref="datatable">
            </kt-datatable>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content';
import { ApiUrl } from '@/common/api.service';
import columns from './datatable/columns';
import manageDataTable from './components/admin-list.vue';
import actions from './datatable/actions';
import { AuthorizationHeader } from '@/common/jwt.service';
import actionBar from '@/components/custom/action-bar';
import filterBar from './components/filter-bar';

export default {
    components: {
        mainContent,
        actionBar,
        filterBar,
        manageDataTable,
    },
    data() {
        return {
            query: {},
        };
    },
    methods: {
        filterAction(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
    },
    computed: {
        datatableProps() {
            return {
                id: "stakeholders_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('stakeholders'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actions,
            }
        },
    },
}
</script>
